
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff, User, Lock } from "lucide-react";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";

interface LoginTabProps {
  onLoginSuccess: () => void;
}

// Authorized admin credentials
const AUTHORIZED_USERNAME = "admin";
const AUTHORIZED_PASSWORD = "7gcadmin";

const LoginTab = ({ onLoginSuccess }: LoginTabProps) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginAttempts, setLoginAttempts] = useState(0);
  
  const { toast } = useToast();
  
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!username || !password) {
      toast({
        title: "Greška",
        description: "Molimo unesite korisničko ime i lozinku",
        variant: "destructive",
      });
      return;
    }
    
    setIsLoading(true);
    
    setTimeout(() => {
      setIsLoading(false);
      
      if (username === AUTHORIZED_USERNAME && password === AUTHORIZED_PASSWORD) {
        toast({
          title: "Uspješna prijava",
          description: "Dobrodošli na 7 for all Global Connect",
        });
        
        localStorage.setItem("7gc_auth", JSON.stringify({
          isAuthorized: true,
          username: AUTHORIZED_USERNAME,
          timestamp: new Date().getTime()
        }));
        
        onLoginSuccess();
      } else {
        setLoginAttempts(prev => prev + 1);
        
        if (loginAttempts >= 2) {
          toast({
            title: "Pristup odbijen",
            description: "Previše neuspješnih pokušaja. Sustav je zabilježio ovu aktivnost.",
            variant: "destructive",
          });
        } else {
          toast({
            title: "Greška pri prijavi",
            description: "Neispravno korisničko ime ili lozinka",
            variant: "destructive",
          });
        }
      }
    }, 1500);
  };

  return (
    <form onSubmit={handleLogin} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="username">Korisničko ime</Label>
        <div className="relative">
          <User className="absolute left-3 top-2.5 h-5 w-5 text-muted-foreground" />
          <Input
            id="username"
            placeholder="Korisničko ime"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="bg-black/50 border-primary/20 text-foreground pl-10 focus:border-primary"
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="password">Lozinka</Label>
        <div className="relative">
          <Lock className="absolute left-3 top-2.5 h-5 w-5 text-muted-foreground" />
          <Input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Lozinka"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bg-black/50 border-primary/20 text-foreground pl-10 pr-10 focus:border-primary"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-2.5 text-muted-foreground hover:text-foreground"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
      </div>
      <Button
        type="submit"
        className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-bold"
        disabled={isLoading}
      >
        {isLoading ? "Prijava u tijeku..." : "PRISTUPI PORTALU"}
      </Button>
    </form>
  );
};

export default LoginTab;
